import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';
import { MAIN_WEBSITE_URL } from '@/mocks/site';

export default function Footer() {
  const { t } = useTranslation();

  const categoryKeys = ['shoes', 'hoodies', 'tshirts', 'jackets', 'pants', 'headwear', 'sets', 'underwear', 'jersey', 'accessories', 'bags', 'belts', 'perfumes', 'other'];

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-links-line text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading font-extrabold text-lg tracking-tight text-foreground-950">
                USFans<span className="text-primary-500">Link</span>
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">{t('footer.tagline')}</p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-950 mb-4">
              {t('footer.quickLinks')}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/usfans-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  {t('nav.guide')}
                </Link>
              </li>
              <li>
                <a
                  href={MAIN_WEBSITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  {t('nav.visitMain')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-950 mb-4">
              {t('footer.categoriesTitle')}
            </h4>
            <ul className="grid grid-cols-1 gap-2.5">
              {categoryKeys.slice(0, 7).map((key) => {
                const cat = categories.find((c) => c.key === key);
                return cat ? (
                  <li key={key}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {t(`category.${key}`)}
                    </a>
                  </li>
                ) : null;
              })}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-950 mb-4">
              {t('footer.legal')}
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">{t('footer.disclaimerText')}</p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} USFansLink · {t('footer.rights')}
          </p>
          <p className="text-xs text-foreground-500">{t('footer.disclaimerTitle')} · {t('footer.tagline')}</p>
        </div>
      </div>
    </footer>
  );
}